import { Chip } from "@mui/material";

export interface StatusChipProps {
  label: string;
  bgcolor: string;
  color: string;
}

const StatusChip = ({ label, bgcolor, color }: StatusChipProps) => (
  <Chip
    label={label}
    size="small"
    className="h-6 text-xs font-semibold"
    sx={{ bgcolor, color }}
  />
);

export default StatusChip;
